import React, { Fragment } from "react";
import Title from 'antd/es/typography/Title';

export default function HanziTile(props) {
  const {
    hanzi,
    pinyin
  } = props;

  return (
    <Fragment>
      <Title level={2}>
        <ruby>
          {hanzi}
          <rt>{pinyin}</rt>
        </ruby>
      </Title>
    </Fragment>
  );
};
